import axios from "../api/axios";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "./useAuth";
import useLogout from "./useLogout";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const logout = useLogout();
  const refresh = async () => {
    const token = localStorage.getItem("rtkn");
    const response = await axios.post(
      "auth/refresh-token",
      { refreshToken: token },
      {
        withCredentials: true,
      }
    );
    if (response.data.message === "Unauthorized") {
      await logout();
    } else {
      const decoded = jwtDecode(response.data.accessToken);
      const token = response.data.accessToken;

      localStorage.setItem("tk", token);

      setAuth({
        id: decoded.id,
        currentCar: decoded.currentCar,
        monitorBy: decoded.monitorBy,
        token: token,
        multipleCars: decoded.multipleCars,
        ndaAccepted: decoded.ndaAccepted,
        paymentWindow: decoded.paymentWindow,
        trialDays: decoded.trialDays,
        membershipAmount: decoded.membershipAmount,
        membership: decoded.membership,
      });
      return token;
    }
  };
  return refresh;
};

export default useRefreshToken;
